export const ADDRESS_SELECT_FIELD_TEMPLATE = (data: { type: string, label: string, street: string, house_number: string, zip_code: string, city: string, country: string }) => {
    let template = `
        <div>
            ${data.street} ${data.house_number}
        </div>
        <div>
            ${data.zip_code} ${data.city}
        </div>
        <div>
            ${data.country}
        </div>
        <div>
            <span class="label label-xs label-info">
                ${data.type}
            </span>
        </div>
    `;

    if (data.label != null) {
        template = `
            <div>
                <span class="label label-xs label-primary">
                    ${data.label}
                </span>
            </div>
            ${template}
        `;
    }

    return template;
};


// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/forms/address/address-select-field-template.ts